define("shared/modifiers/scroll-to-top", ["exports", "ember-modifier"], function (_exports, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-modifier"eaimeta@70e063a35619d71f

  /**
   *
   * @class ScrollToTopModifier
   * @extends Modifier
   *
   * ScrollToTopModifier will automatically scroll to the top of the chosen element.
   *
   * Positional Parameters:
   * @param {String} className The className to be targeted for scrolling
   *
   * Usage:
   * Will force the targeted element to scroll to the top when the modifier is loaded in
   * <RandomElement {{scroll-to-top "targetClass"}} />
   *
   */
  class ScrollToTopModifier extends _emberModifier.default {
    get targetClassName() {
      return this.args.positional[0];
    }

    didInstall() {
      const targetElement = document.getElementsByClassName(this.targetClassName)[0];
      targetElement.scrollTop = 0;
    }

  }

  _exports.default = ScrollToTopModifier;
});